import { useEffect, useRef, useState } from 'react';

export default function CountUp({ value, durationSeconds }) {
  const [displayed, setDisplayed] = useState(value);
  const current = useRef(value);
  const frame = useRef(null);

  useEffect(() => {
    if (value <= current.current) {
      current.current = value;
      setDisplayed(value);
      return undefined;
    }

    const from = current.current;
    const start = performance.now();

    const step = (now) => {
      const progress = Math.min(1, (now - start) / (durationSeconds * 1000));
      current.current = Math.round(from + (value - from) * progress);
      setDisplayed(current.current);
      if (progress < 1) {
        frame.current = requestAnimationFrame(step);
      }
    };

    frame.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frame.current);
  }, [value, durationSeconds]);

  return displayed.toLocaleString();
}
